//importer les feuille de styles et js
import './assets/styles/core.scss';
import './assets/script/script.js';